export default __webpack_public_path__ + "static/Sweet_Vegetable_Cake-854d9ed77af038fd8c7778267dbfd652.png";